import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../../candidature-formation.model';
import {GrhumService, Pays} from '../../../grhum';
import {FormationService, Question} from '../../../formation';
import {ParametrageService} from '../../../parametrage';
import {CONSTANTS} from '../../../../cadens.constants';
import {Response} from '@angular/http';
import {FormationComponentService} from '../formationComponent.service';
import {AlertService} from 'ng-jhipster';
import {UserEnEchange} from '../../../user-en-echange';
import {TranslateService} from 'ng2-translate';
import {Cours} from '../../cours.model';
import {CoursDisponibleService} from '../../../cours-disponible/cours-disponible.service';
import {CoursDisponible} from '../../../cours-disponible/cours-disponible.model';
import {Cursus} from '../../cursus.model';

@Component({
    selector: 'jhi-international-component',
    templateUrl: 'international.component.html'
})
export class InternationalComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() isEditable: Boolean;
    @Input() questions: Question[];
    @Input() questionsChange: EventEmitter<Question[]>;
    @Input() currentLang: string;
    @Input() isBO: number;
    @Input() userEnEchange: UserEnEchange;
    @Input() listeCours: Cours[];
    @Output() btnActivation = new EventEmitter();
    @Output() listeCoursChange: EventEmitter<Cursus[]> = new EventEmitter();

    parametrage: any;
    paysListe: Pays[];
    isSaving = false;
    listeCoursDisponible: CoursDisponible[] ;
    public paysOrigine: Pays = new Pays();

    constructor(private parametrageService: ParametrageService,
                private translate: TranslateService,
                private grhumService: GrhumService,
                private formationService: FormationService,
                private formationComponentService: FormationComponentService,
                private alertService: AlertService,
                private coursDisponibleService: CoursDisponibleService) {
    }

    ngOnInit() {
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);

        this.parametrageService.query({page: CONSTANTS.INTERNATIONAL}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.grhumService.queryPays().subscribe(
            (res: Response) => {
                this.paysListe = res.json();
                if (this.userEnEchange && this.userEnEchange.codePaysUniversite && this.paysListe) {
                    this.paysOrigine = this.paysListe.find(pays => pays.code === this.userEnEchange.codePaysUniversite);
                    if ( ! this.paysOrigine) {
                        this.paysOrigine = Pays.getPaysInconnu(this.userEnEchange.codePaysUniversite) ;
                    }
                }
            }, (res: Response) => this.onError(res.json()));
        this.coursDisponibleService.findByAnneeEnCours().subscribe(
            (res: CoursDisponible[]) => {
                this.listeCoursDisponible = res;
            });
        this.findFormationEchangeInternational();
        if (!this.listeCours || this.listeCours.length == 0) {
            this.addCours();
        }
        // this.candidatureFormation.paysUniversiteOrigine=this.userEnEchange.codePaysUniversite ;
        // this.candidatureFormation.nomUniversiteOrigine=this.userEnEchange.nomUniversiteOrigine ;
        // this.candidatureFormation.typeEchangeInternational=this.userEnEchange.typeEchange ;
    }


    private onError(error) {
        this.isSaving = false;
        this.alertService.error(error.message, null, null);
    }


    addCours() {
        if (!this.listeCours) {
            this.listeCours = [];
        }
        this.listeCours.push(this.newCours());
        this.listeCoursChange.emit(this.listeCours);
    }

    clearCours(index) {
        this.listeCours.splice(index, 1);
    }

    private newCours(): Cours {
        let cours = new Cours();
         return(cours);
    }


    findFormationEchangeInternational() {
        this.formationService.findPourEtudiant(
            CONSTANTS.ECHANGE_INTERNATIONAL_ID, this.candidatureFormation.userId
        ).subscribe(
            (formation) => {
                this.candidatureFormation.formationId = formation.id;
                this.candidatureFormation.libelle = formation.libelle;
                this.formationComponentService.changeFormation(this.candidatureFormation.formationId);
            });
    }

    clickBoutonQuestion(buttonAction: String) {
        this.btnActivation.emit({value: buttonAction}) ;
    }

    onCoursChanged(cours: Cours) {
 /*       if (this.listeCours != null && cours!=null && this.listeCours.length > cours.index) {
            this.listeCours[cours.index] = cours;
        }
*/    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/international/international.component.ts